import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useBreadcrumb } from '../contexts/BreadcrumbContext';

export default function Breadcrumb() {
  const { items } = useBreadcrumb();

  if (items.length <= 1) return null;

  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={item.path} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="h-4 w-4 text-gray-400 mx-1" />
              )}
              {isLast ? (
                <span className="text-gray-700">{item.label}</span>
              ) : (
                <Link 
                  to={item.path} 
                  className="text-green-600 hover:text-green-700"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}